export const CalendarAssistant = {
    "Calendar": {
        items: [
            // Viewing your calendar
            {
                heading: 'Viewing your calendar',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar'],
                sections: [
                    {
                        description: 'To view your calendar, navigate to your calendar using the menu bar or the <b>View My Calendar</b> option on the calendar dashboard card',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Changing between month / week / day view
            {
                heading: 'Changing between month / week / day view',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'day', 'month', 'week', 'filter'],
                sections: [
                    {
                        description: 'To change your calendar view, navigate to your calendar using the menu bar or the <b>View My Calendar</b> option on the calendar dashboard card',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing your calendar'
                            }
                        }
                    }, {
                        description: 'On top top calendar filter bar, change the view by selecting the appropriate view icon under the view section',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Managing another persons calendar
            {
                heading: 'Managing another persons calendar',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'patient', 'client', 'doctor', 'clinician', 'manage'],
                sections: [
                    {
                        description: 'To manage another persons calendar, navigate to your calendar using the menu bar or the <b>View My Calendar</b> option on the calendar dashboard card',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing your calendar'
                            }
                        }
                    }, {
                        description: 'On top top calendar filter bar, under the calendar sub section, choose the search the persons name you would like to manage and select the appropriate result',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Creating a calendar entry
            {
                heading: 'Creating a calendar entry',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'day', 'month', 'week', 'filter', 'add', 'entry', 'create'],
                sections: [
                    {
                        description: 'To creating a calendar entry, navigate to your calendar using the menu bar or the <b>View My Calendar</b> option on the calendar dashboard card',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing your calendar'
                            }
                        }
                    }, {
                        description: 'Click the date / time slot you would like to create the entry for based on your current view',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'Changing calendar views',
                                module: 'Calendar',
                                sectionName: 'Changing between month / week / day view'
                            }
                        }
                    }, {
                        description: 'Under the calendar <b>options</b>, select the type of event you would like to create',
                        styleAs: 'list',
                    }, {
                        description: 'Enter in the calendar entry details, select next',
                        styleAs: 'list',
                    }, {
                        description: 'If there is a clinician assigned to the event the system will ask if you would like to create an entry on their calendar, confirm the details and select next',
                        styleAs: 'note',
                    }, {
                        description: 'If there is a patient assigned to the event the system will ask if you would like to create an entry on their calendar, confirm the details and select next',
                        styleAs: 'note',
                    }, {
                        description: 'If you have additional linked calendars the system will ask if you would like to create an entry on the calendar, confirm the details and select next',
                        styleAs: 'note',
                    },
                    {
                        description: 'If you would like to assign a status icon and / or colour to the event, choose as such and click <b>Done</b>',
                        styleAs: 'list',
                    }, {
                        description: 'The system will create the calendar entries, and show you an overview for the day',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Viewing a calendar entry
            {
                heading: 'Viewing a calendar entry',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'day', 'month', 'week', 'filter', 'add', 'entry', 'create'],
                sections: [
                    {
                        description: 'To viewing a calendar entry, navigate to your calendar using the menu bar or the <b>View My Calendar</b> option on the calendar dashboard card',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing your calendar'
                            }
                        }
                    }, {
                        description: 'Click the entry you would like to view based on your current view',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'Changing calendar views',
                                module: 'Calendar',
                                sectionName: 'Changing between month / week / day view'
                            }
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Adding a note to a calendar entry
            {
                heading: 'Adding a note to a calendar entry',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'day', 'month', 'week', 'entry', 'note'],
                sections: [
                    {
                        description: 'View the calendar entry you would like to add a note to',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing a calendar entry'
                            }
                        }
                    }, {
                        description: 'Select <b>MORE OPTIONS</b> on the top of the entry details',
                        styleAs: 'list'
                    },
                    {
                        description: 'Select Notes',
                        styleAs: 'list'
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Adding a document to a calendar entry
            {
                heading: 'Adding a document to a calendar entry',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'day', 'month', 'week', 'entry', 'document'],
                sections: [
                    {
                        description: 'View the calendar entry you would like to add a document to',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing a calendar entry'
                            }
                        }
                    }, {
                        description: 'Select <b>MORE OPTIONS</b> on the top of the entry details',
                        styleAs: 'list'
                    },
                    {
                        description: 'Select Documents',
                        styleAs: 'list'
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            // Linking a message to a calendar entry
            {
                heading: 'Linking a message to a calendar entry',
                // description: 'Viewing your calendar',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['calendar', 'day', 'month', 'week', 'entry', 'message'],
                sections: [
                    {
                        description: 'View the calendar entry you would like to link a message to',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Calendar',
                                sectionName: 'Viewing a calendar entry'
                            }
                        }
                    }, {
                        description: 'Select <b>MORE OPTIONS</b> on the top of the entry details',
                        styleAs: 'list'
                    },
                    {
                        description: 'Select <b>Messages</b>',
                        styleAs: 'list'
                    },
                ],
                options: [
                    {
                        option: 'Take me to my calendar',
                        action: {
                            type: 'location',
                            value: '/Dashboard/Calendar',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}